import { ClosedByUserError } from 'Classes';
import { app } from '@/main';
import { makeQueryablePromise } from 'Utils/promise';

export { ClosedByUserError };
export * from './independentModal';

let modalStore = [];

function getModalContainer() {
  return app.$children?.[0]?.$refs.modal;
}

function clearModalStore() {
  modalStore = [];
}

function removeItemFromModalStoreByModalComponent(modalComponent) {
  modalStore = modalStore.filter(item => item.modalComponent !== modalComponent);
}

export function closeModal() {
  const modalContainer = getModalContainer();
  modalContainer.closeModal();
  clearModalStore();
}

function setCurrentModal(modalComponent, props, options) {
  const modalContainer = getModalContainer();
  modalContainer.setCurrentModal(modalComponent, props, options);
}

function getNormalizedOptions(options) {
  // if options equal false, means ignoreErrorOnUserClose and closeOnSuccess are false
  if (options === false) {
    return { ignoreErrorOnUserClose: false, closeOnSuccess: false };
  }
  // closeOnSuccess is true by default
  const closeOnSuccess = options?.closeOnSuccess !== undefined ? options.closeOnSuccess : true;

  return { ...options, closeOnSuccess };
}

function getCallbacks(modalComponent, options, resolve, reject) {
  function onError(error) {
    reject(error);
    if (options.closeOnError) closeModal();
  }

  function onSuccess(value) {
    resolve(value);
    if (options.closeOnSuccess) closeModal();
  }

  function onCancel() {
    if (options.temporary) {
      removeItemFromModalStoreByModalComponent(modalComponent);
    } else {
      clearModalStore();
    }
    if (options.ignoreErrorOnUserClose === false) {
      reject(new ClosedByUserError());
    } else {
      resolve();
    }
  }

  return {
    onSuccess,
    onCancel,
    onError,
  };
}

function getNewModalPromiseObject(modalComponent) {
  let resolveSave;
  let rejectSave;

  const promise = new Promise((resolve, reject) => {
    resolveSave = resolve;
    rejectSave = reject;
  });

  const queryablePromise = makeQueryablePromise(promise);
  return { modalComponent, promise: queryablePromise, resolve: resolveSave, reject: rejectSave };
}

function getModalPromiseObject(modalComponent) {
  const existModalObject = modalStore.find(item => item.modalComponent === modalComponent);
  if (existModalObject?.promise?.isPending?.()) return existModalObject;

  const newModalPromiseObject = getNewModalPromiseObject(modalComponent);
  modalStore.push(newModalPromiseObject);

  return newModalPromiseObject;
}

/**
 * Open modal
 * @param modalComponent
 * @param props {Object} - props for modal
 * @param options {false} - false for options.ignoreErrorOnUserClose and options.closeOnSuccess
 * @param options {Object} - options
 * @param [options.closeOnSuccess=true] {Boolean}  - is close modal on success
 * @param [options.closeOnError=true] {Boolean} - is close modal on error
 * @param [options.ignoreErrorOnUserClose=true] {Boolean} - is close modal get success from it
 * @param options.temporary {boolean} - is this modal open temporary from another modal. In this case after temporary modal close, modal store will not clear
 */
export function openModal(modalComponent, props = {}, options = {}) {
  const normOptions = getNormalizedOptions(options);
  const modalPromiseObject = getModalPromiseObject(modalComponent);
  const callbacks = getCallbacks(modalComponent, normOptions, modalPromiseObject.resolve, modalPromiseObject.reject);
  const allOptions = { ...normOptions, ...callbacks };

  setCurrentModal(modalComponent, props, allOptions);

  return modalPromiseObject.promise;
}
